import { render } from "./EquipamentosDoArtigo.vue?vue&type=template&id=58a0211c&scoped=true"
import script from "./EquipamentosDoArtigo.vue?vue&type=script&lang=js"
export * from "./EquipamentosDoArtigo.vue?vue&type=script&lang=js"

import "./EquipamentosDoArtigo.vue?vue&type=style&index=0&id=58a0211c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a0211c"]])

export default __exports__